export default __webpack_public_path__ + "static/hackathon-as-a-service-fallback-20967d1abd1448ff8e37e32f9218a10c.jpg";